import {createReducer, on} from '@ngrx/store';
import {Toggles} from './toggles';
import {aktualizuToggle} from './toggles.actions';
import {Toggle} from '../../toggle';


export const initialTogglesState: Toggles = {}

export const togglesReducer = createReducer(
  initialTogglesState,
  on(aktualizuToggle, (state, action) => {
    Toggle.validateToggles(action.toggles)
    return {
      ...state,
      ...action.toggles
    }
  }),
);

